import { useMovedToTrashToast } from "@/domain/trash/hooks/use-moved-to-trash-toast";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteDataRequestMutation } from "./data-request.gql";

interface DeleteDataRequestResponse {
  deleteDataRequest: { id: string };
}

interface UseDeleteDataRequestProps {
  onCompleted?: () => void;
  onError?: () => void;
}

export function useDeleteDataRequestMutation({ onCompleted, onError }: UseDeleteDataRequestProps = {}) {
  const queryClient = useQueryClient();
  const notifyMovedToTrash = useMovedToTrashToast();

  const mutation = useMutation({
    mutationFn: async (params: { id: string; workspaceId: string }) => {
      const client = createOperationClient("DeleteDataRequest");
      const data = await client.request<DeleteDataRequestResponse>(deleteDataRequestMutation, params);
      return data.deleteDataRequest;
    },
    onSuccess: (deletedDataRequest) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.dataRequests.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.trash.lists() });
      notifyMovedToTrash({ entityType: "dataRequest", idList: [deletedDataRequest.id] });
      onCompleted?.();
    },
    onError: () => {
      onError?.();
    },
  });

  return {
    deleteDataRequest: mutation.mutate,
    loading: mutation.isPending,
  };
}
